/** @jsx jsx */
import React, { useContext } from 'react'
import { css, jsx } from '@emotion/react'

import CampaignQuotesWrapper from 'agency/digital_renderer/components/CampaignQuotesWrapper'
import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceCustomCSS from 'agency/digital_renderer/utils/deviceCustomCSS'

import Quote from './Quote'
import styles from './styles.scss'

const renderQuoteToggle = (renderProps, customCSS) => {
  const { campaignQuotes, selectedQuoteId, selectQuoteId } = renderProps
  if (!campaignQuotes.length) return null

  const customToggleCSS = customCSS.quoteToggle

  return (
    <ul
      className={customToggleCSS ? null : styles.quoteToggle}
      css={
        customToggleCSS
          ? css`
              ${customToggleCSS}
            `
          : null
      }
    >
      {campaignQuotes.map((quote) => {
        const selected = quote.id === selectedQuoteId
        return (
          <li key={quote.id}>
            <a
              className={!customToggleCSS && selected ? styles.selected : null}
              data-selected={selected}
              tabIndex="0"
              onClick={() => selectQuoteId(quote.id)}
            >
              {quote.title}
            </a>
          </li>
        )
      })}
    </ul>
  )
}

const renderQuote = (brand, renderProps, context, customCSS) => {
  const { campaignQuote } = renderProps
  const { printMode } = context

  return (
    <div
      css={
        customCSS.root
          ? css`
              ${customCSS.root}
            `
          : null
      }
    >
      {!printMode && renderQuoteToggle(renderProps, customCSS)}
      <Quote brand={brand} campaignQuote={campaignQuote} customCSS={customCSS} />
    </div>
  )
}

const Quotes = (props) => {
  const defaultContext = useContext(GlobalContext)
  const { brand, dataSource } = defaultContext

  const customCSS = deviceCustomCSS(props)

  return (
    <CampaignQuotesWrapper
      dataSource={dataSource}
      render={params => renderQuote(brand, params, defaultContext, customCSS)}
    />
  )
}

export default Quotes
